import React, { useState, useEffect, useRef } from "react";

import "./slicknav.css";
import "./main.css";

const navItems = [
  { label: "Home", target: "home" },
  { label: "Work", target: "work" },
  { label: "Services", target: "services" },
   { label: "Testimonials", target: "testimonials" },
  { label: "Brands", target: "brands" },
  { label: "Vision", target: "vision" },
  { label: "About Us", target: "contact" },
];

const Header = () => {
  const [scroll, setScroll] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const clickedTarget = useRef("");
  const clickedTargetTimer = useRef(null);
  const lastClickedTarget = useRef("");
  const lastClickedScrollY = useRef(0);
  const navRef = useRef(null);
  const buttonRefs = useRef({});

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 10);

      if (clickedTarget.current) {
        setActiveTab(clickedTarget.current);
        return;
      }

      const headerOffset = window.scrollY > 10 ? 78 : 94;
      const triggerPoint = headerOffset + window.innerHeight * 0.35;
      const footerSection = document.getElementById("contact");
      const footerTop = footerSection
        ? footerSection.getBoundingClientRect().top
        : Infinity;
      const footerIsVisible =
        footerSection &&
        footerSection.getBoundingClientRect().top < window.innerHeight - 80 &&
        footerSection.getBoundingClientRect().bottom > headerOffset;
      const shouldHoldPreviousClickedSection =
        lastClickedTarget.current &&
        lastClickedTarget.current !== "contact" &&
        Math.abs(window.scrollY - lastClickedScrollY.current) < 80;

      const currentSection =
        (footerTop <= triggerPoint || footerIsVisible) &&
        !shouldHoldPreviousClickedSection
          ? navItems[navItems.length - 1]
          : [...navItems].reverse().find((item) => {
              const section = document.getElementById(item.target);

              if (!section || item.target === "contact") {
                return false;
              }

              return section.getBoundingClientRect().top <= triggerPoint;
            });

      if (currentSection) {
        setActiveTab(currentSection.target);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.clearTimeout(clickedTargetTimer.current);
    };
  }, []);

  useEffect(() => {
    const nav = navRef.current;
    const btn = buttonRefs.current[activeTab];
    if (!nav || !btn) return;
    const navLeft = nav.getBoundingClientRect().left;
    const navWidth = nav.offsetWidth;
    const btnLeft = btn.getBoundingClientRect().left;
    const btnWidth = btn.offsetWidth;
    const scrollTarget = nav.scrollLeft + (btnLeft - navLeft) - navWidth / 2 + btnWidth / 2;
    nav.scrollTo({ left: scrollTarget, behavior: "smooth" });
  }, [activeTab]);

  const scrollToSection = (target) => {
    const section = document.getElementById(target);

    if (!section) {
      return;
    }

    clickedTarget.current = target;
    lastClickedTarget.current = target;
    window.clearTimeout(clickedTargetTimer.current);
    setActiveTab(target);

    const headerOffset = scroll ? 66 : 78;
    const sectionTop =
      section.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: sectionTop,
      behavior: "smooth",
    });

    clickedTargetTimer.current = window.setTimeout(() => {
      clickedTarget.current = "";
      lastClickedScrollY.current = window.scrollY;
    }, 900);
  };

  return (
    <header
      id="header"
      className={scroll ? "arcus-header arcus-header-scrolled" : "arcus-header"}
    >
      <div className="logo-box">
        <img
          src={require("../../images/arcus-header-logo-cropped.png").default}
          alt="Arcus Builders and Developers"
        />
      </div>

      <nav className="nav-menu" ref={navRef} aria-label="Primary navigation">
        {navItems.map((item) => (
          <button
            key={item.target}
            ref={(el) => (buttonRefs.current[item.target] = el)}
            className={activeTab === item.target ? "active" : ""}
            type="button"
            onClick={() => scrollToSection(item.target)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      <a className="call-box" href="tel:+919605063111">
        <span>Call us</span>
        <strong>+91 9605063111</strong>
      </a>
    </header>
  );
};
export default Header;
